"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _preactCompat = require("preact-compat");

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _DeletePrivateMessage = _interopRequireDefault(require("./DeletePrivateMessage"));

var _ReportPrivateMessageButton = _interopRequireDefault(require("./ReportPrivateMessageButton"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PrivateMessageTooltip = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(PrivateMessageTooltip, _PureComponent);

  var _super = _createSuper(PrivateMessageTooltip);

  function PrivateMessageTooltip() {
    (0, _classCallCheck2.default)(this, PrivateMessageTooltip);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(PrivateMessageTooltip, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          messageId = _this$props.messageId,
          canDelete = _this$props.canDelete,
          setAlertMessage = _this$props.setAlertMessage,
          phrases = _this$props.phrases,
          onReport = _this$props.onReport;
      var tooltipComponent = canDelete ? (0, _preact.h)(_DeletePrivateMessage.default, {
        messageId: messageId,
        errorCallback: setAlertMessage,
        phrases: phrases
      }) : (0, _preact.h)(_ReportPrivateMessageButton.default, {
        onReport: onReport
      });
      return (0, _preact.h)("div", {
        className: "private-message-tooltip"
      }, (0, _preact.h)("span", {
        className: "text--meta"
      }, (0, _preact.h)(_Tooltip.default, {
        trigger: (0, _preact.h)("span", {
          className: (0, _classnames.default)('icon--auto-width', 'icon--ellipsis', 'qa-private-message-ellipsis')
        }),
        tooltipMessage: tooltipComponent
      })));
    }
  }]);
  return PrivateMessageTooltip;
}(_preactCompat.PureComponent);

var _default = PrivateMessageTooltip;
exports.default = _default;